export default __webpack_public_path__ + "static/media/artist.4a8daef7.png";